/*
 * Accept: User Resource
 */
const SET_CURRENT_USER = (state, data) => {
  if ("user" in data) {
    let user = data.user
    let roles = {}

    _.forEach(user.roles, function(role) {
      let permissions = {}

      _.forEach(role.permissions, function(permission) {
        permissions[permission.id] = permission.name
      })

      roles[role.id] = {
        name: role.name,
        slug: role.slug,
        permissions: permissions
      }
    })

    user.roles = roles
    user["accessToken"] = data.token

    localStorage.setItem("__crrntUser", JSON.stringify(user))

    // SET USER AND ROLES TO VUEX STATE
    state.user = user
  } else {
    localStorage.setItem("__crrntUser", data)
  }
}

export default {
  SET_CURRENT_USER
}
